<script setup>
  const props = defineProps(['fighter', 'corner']);
</script>

<!----------------------------------------------------------------------------->

<template>
  <ClickableCard :to="fighter?.url">
    <img
      v-if="fighter && fighter[corner]"
      :src="fighter[corner].url"
      :alt="fighter.last_name"
      width="280"
      height="360"
    />
    <img
      v-else
      :src="useCdn().generateStaticAsset(`images/fighter_silhouette_${corner}.png`)"
      :alt="fighter ? fighter.title : 'TBD'"
      width="280"
      height="360"
    />
    <!-- <img
      v-else-if="fighter && fighter.thumbnail"
      :src="fighter.thumbnail.url"
      :alt="fighter.last_name"
      width="280"
      height="360"
    /> -->

    <div class="name">
      <h4>{{ fighter?.last_name ?? 'TBD' }}</h4>
    </div>
  </ClickableCard>
</template>

<!----------------------------------------------------------------------------->

<style lang="scss" scoped>
  a {
    box-sizing: content-box;

    width: 100%;
    height: 100%;

    display: flex;
    flex-direction: column;

    img {
      margin: px(-16) 0 px(-16);
      height: auto;
    }

    .name {
      height: 100%;
      border-top: px(1) solid $black-5;

      @include heroic-bold(px(24));

      display: flex;
      align-items: center;
      justify-content: center;

      background-color: $black;

      h4 {
        margin-top: 0.08em;
      }
    }

    @include break-small {
      .name {
        height: px(80);
        h4 {
          font-size: px(32);
        }
      }
    }

    @include break-phone {
      height: 65vw;
      overflow: hidden;

      img {
        width: 140%;
        margin: px(8) 0 0 -20%;
      }

      .name {
        position: absolute;

        width: 100%;
        height: px(60);

        bottom: 0;
      }
    }
  }
</style>
